import styled from "styled-components"

const NotificationsContainer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1800;
    width: 100%;
`

export default NotificationsContainer